export enum SavedCartFormType {
  EDIT = 'edit',
  DELETE = 'delete',
  SAVE = 'save',
  RESTORE = 'restore',
}
